/**
 * The readable guard (combat design docs/design/combat/2026-10-11-guard-read, approved by the user 10-11). Defaults
 * proposed by the combat designer, to be tuned by ns-balance:
 * - `weakShare`: at or under this share of the guard points the guard reads weak (the sagging pose and the red cue on
 *   the body; picture only).
 * - `dropFrames`: letting a raised guard go in a bout's fight costs this many 60 Hz frames of recovery (systems/
 *   duelGuardDrop.ts through the bout's recovery lock: no skill, dash or jump, the basic cut held back, the guard held
 *   back and given back if the key is still down), so a predictable release can be punished.
 */
export const GUARD_READ = { weakShare: 0.35, dropFrames: 6 } as const;
